import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import user from './modules/user'
import testdata from './modules/testdata'
import article from './modules/article'

import VuexPersistence from "vuex-persist";//用于将 Vuex 的状态持久化保存到浏览器的存储机制中（如 localStorage、sessionStorage 或 Cookie）

Vue.use(Vuex)

const SHARE_DATA = {
  list: [],
  obj: {},
  boolValue: false,
  msg: '',
};

const vuexLocal = new VuexPersistence({
  storage: window.localStorage, // 或者 window.sessionStorage
  reducer: state => ({
    // 这里指定哪些状态需要被持久化
    //cart: state.cart,
    user: state.user,
  })
});
//vuex modules之间的调用
//---跨模块访问 State，‌通过 rootState
export default new Vuex.Store({
  modules: {
    user,
	article,
	testdata
  },
  state: {
    sharedData: {
      list: [],
      obj: {},
      boolValue: false,
      msg: '',
    },
	test: '666',
	screenWidth:1028,
  },
  mutations: {
    setData(state, data) {
      state.sharedData = Object.assign({}, SHARE_DATA, data)
    },	
	setScreenWidth(state, data) {
		state.screenWidth = data
	}
  
  },
  actions: {},
  getters,
  plugins: [vuexLocal.plugin], // 将 vuexLocal.plugin 作为插件添加到 store 中,

})